// Maps Prohandel sync_job `details.phase` strings (emitted by
// backend/src/prohandel/sync.rs::update_phase) to operator-facing labels for
// the global sync bar. Unknown phases fall back to "Syncing" so a new
// backend phase never shows a raw snake_case token.
const PHASE_LABELS: Record<string, string> = {
	discovering_branches: "Discovering branches",
	fetching_lookups: "Fetching lookups",
	syncing_articles: "Walking articles",
	scanning_in_stock: "Scanning in-stock",
	fetching_in_stock_sizes: "Scanning in-stock",
	syncing_in_stock_articles: "Walking articles",
	upserting_in_stock_sizes: "Saving stock",
	syncing_sizes: "Saving sizes",
	upserting_articles: "Saving articles",
	upserting_sizes: "Saving sizes",
	fetching_changed_articles: "Fetching changes",
	fetching_changed_sizes: "Fetching changes",
	rebuilding_catalogue: "Rebuilding catalogue",
};

export function syncPhaseLabel(phase: string | null | undefined): string {
	if (!phase) return "Syncing";
	return PHASE_LABELS[phase] ?? "Syncing";
}
